// extracted by mini-css-extract-plugin
export default {"premium__text":"ImageGeneratorOnlyForPremium_premium__text__5XFvo","premium__link":"ImageGeneratorOnlyForPremium_premium__link__gthFg"};